import React from "react";
import { styled } from "@mui/material/styles";
import { Store } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";

const PREFIX = "ShopNotFoundContainer";

const classes = {
  button: `${PREFIX}-button`,
  anchor: `${PREFIX}-anchor`,
};

const Root = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  fontDisplay: "swap",
  backgroundColor: "#FFFBF6",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(0, 3),
  [`& .${classes.button}`]: {
    fontWeight: 600,
  },

  [`& .${classes.anchor}`]: {
    textDecoration: "none",
  },
}));

const ShopNotFoundContainer = () => {
  return (
    <Root>
      <Store color="inherit" style={{ fontSize: "80px" }} />
      <Typography
        variant="h4"
        style={{ paddingTop: "20px", paddingBottom: "16px", fontWeight: 500 }}
      >
        Shop Not Found!
      </Typography>
      <a
        href="https://admin.carteapp.io/register"
        className={classes.anchor}
        target="_blank"
        rel="noreferrer"
        title="Create an account with Carte"
      >
        <Button variant="contained" color="secondary" className={classes.button}>
          Launch Your Shop Under This URL
        </Button>
      </a>
    </Root>
  );
};

export default ShopNotFoundContainer;
